import { useAppDispatch, useAppSelector } from 'store/hooks';
import React from 'react';
import { SettingDisplayText } from 'components/settings/SettingDisplayText';
import { IPointOfSaleSettingsProps } from 'components/settings/PointOfSaleSettings';
import { getAllPerks } from 'store/perks/perksSlice';
import { SettingDisplay } from 'lib/SettingDisplay';
import { Chip } from '@mui/material';
import { getGoodtillPriceSourceLabel } from './goodtill';

export function GoodtillSettingsDisplay({ settings, locationId }: IPointOfSaleSettingsProps) {
    const dispatch = useAppDispatch();
    const { perks } = useAppSelector(state => state.perks);

    React.useEffect(() => {
        if (perks.length === 0) {
            dispatch(getAllPerks());
        }
    }, [dispatch, perks.length]);
    const selectedPerk = React.useMemo(
        () => perks.find(perk => perk._id === settings?.goodtill?.loyaltyAtPOSPerkId),
        [perks, settings]
    );

    return (
        <>
            {/* Common Only */}
            {locationId === undefined && (
                <>
                    <SettingDisplayText
                        title="Verification Token"
                        text={settings?.goodtill?.verificationToken}
                    />
                    <SettingDisplayText title="Loyalty At POS Perk" text={selectedPerk?.title} />
                </>
            )}
            {/* Location Only */}
            {locationId !== undefined && (
                <SettingDisplayText title="Outlet Id" text={settings?.goodtill?.outletId} />
            )}
            {/* Both */}
            <SettingDisplayText title="Subdomain" text={settings?.goodtill?.subdomain} />
            <SettingDisplayText title="Username" text={settings?.goodtill?.username} />
            <SettingDisplayText title="Password" text={settings?.goodtill?.password} />
            <SettingDisplay label="Preorder Price Source">
                <Chip
                    label={getGoodtillPriceSourceLabel(settings?.goodtill?.PREORDER_priceSource)}
                    color="primary"
                />
            </SettingDisplay>
            <SettingDisplay label="Order to Table Price Source">
                <Chip
                    label={getGoodtillPriceSourceLabel(settings?.goodtill?.ORDER_TO_TABLE_priceSource)}
                    color="primary"
                />
            </SettingDisplay>
        </>
    );
}
